import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ErrorState } from './components/ErrorState';
import { EmptyState } from './components/EmptyState';
import { LoadingState } from './components/LoadingState';
function render(renderable) {
    if (renderable === undefined)
        return null;
    return typeof renderable === 'function' ? renderable() : renderable;
}
export default function DDataStateWrapper({ isLoading, isError, data, onRetry, renderLoading, renderEmpty, renderError, children, }) {
    // 1. Loading
    if (isLoading) {
        if (renderLoading)
            return render(renderLoading);
        return _jsx(LoadingState, {});
    }
    // 2. Error
    if (isError) {
        if (renderError)
            return render(renderError);
        return (_jsx(ErrorState, { onRetry: onRetry }));
    }
    // 3. Empty
    if (!(data === null || data === void 0 ? void 0 : data.length)) {
        if (renderEmpty)
            return render(renderEmpty);
        return (_jsx(EmptyState, {}));
    }
    // 4. Success
    return _jsx(_Fragment, { children: children(data) });
}
//# sourceMappingURL=DDataStateWrapper.js.map